import { useState } from 'react';
import {useStores} from "../../store";

export type DownloadState = 'idle' | 'downloading' | 'success' | 'error';

interface UseDownloadPdfReturn {
    downloadStates: Record<string, DownloadState>;
    downloadPdf: (pdfId: string, orderId: string) => Promise<void>;
    resetDownloadState: (pdfId: string) => void;
}

export const useDownloadPdf = (): UseDownloadPdfReturn => {
    const { therapyStore } = useStores();
    const [downloadStates, setDownloadStates] = useState<Record<string, DownloadState>>({});

    const downloadPdf = async (pdfId: string, orderId: string): Promise<void> => {
        setDownloadStates(prev => ({ ...prev, [pdfId]: 'downloading' }));

        try {
            const response = await therapyStore.downloadOrderPdf(pdfId);

            // Create a blob from the response data
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // Create a temporary link element and click it
            const link = document.createElement('a');
            link.href = url;
            link.download = `${orderId}.pdf`;
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Set success state
            setDownloadStates(prev => ({ ...prev, [pdfId]: 'success' }));

            // Reset to idle after 5 seconds
            setTimeout(() => {
                setDownloadStates(prev => ({ ...prev, [pdfId]: 'idle' }));
            }, 5000);

        } catch (error) {
            setDownloadStates(prev => ({ ...prev, [pdfId]: 'error' }));
        }
    };

    const resetDownloadState = (pdfId: string): void => {
        setDownloadStates(prev => ({ ...prev, [pdfId]: 'idle' }));
    };

    return {
        downloadStates,
        downloadPdf,
        resetDownloadState
    };
};